<h2 mat-dialog-title translate="MEETINGS.EXPORT_DIALOG.TITLE"></h2>
<mat-dialog-content>
  <p translate="MEETINGS.EXPORT_DIALOG.DESCRIPTION"></p>
  @if (data.allowTranscriptDownload) {
    <div class="item">
      <mat-checkbox name="include-transcript" [disabled]="!data.hasTranscript" labelPosition="after" [(ngModel)]="exportData.includeTranscript"
        >{{ 'MEETINGS.EXPORT_DIALOG.TRANSCRIPT' | translate }}
      </mat-checkbox>
      @if (exportData.includeTranscript) {
        <mat-button-toggle-group name="transcript-format" [(ngModel)]="exportData.transcriptFormat">
          <mat-button-toggle value="docx">DOCX</mat-button-toggle>
          <mat-button-toggle value="pdf">PDF</mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>
  }
  @if (data.canDownloadMinutes) {
    <div class="item">
      <mat-checkbox name="include-minutes" [disabled]="!data.hasMinutes" labelPosition="after" [(ngModel)]="exportData.includeMinutes">{{
        'MEETINGS.EXPORT_DIALOG.MINUTES' | translate
      }}</mat-checkbox>
      @if (exportData.includeMinutes) {
        <mat-button-toggle-group name="minutes-format" [(ngModel)]="exportData.minutesFormat">
          <mat-button-toggle value="docx">DOCX</mat-button-toggle>
          <mat-button-toggle value="pdf">PDF</mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>
  }
  @if (data.allowOutlineDownload) {
    <div class="item">
      <mat-checkbox name="include-outline" [disabled]="!data.hasOutline" labelPosition="after" [(ngModel)]="exportData.includeOutline">{{
        'MEETINGS.EXPORT_DIALOG.OUTLINE' | translate
      }}</mat-checkbox>
      @if (exportData.includeOutline) {
        <mat-button-toggle-group name="outline-format" [(ngModel)]="exportData.outlineFormat">
          <mat-button-toggle value="docx">DOCX</mat-button-toggle>
          <mat-button-toggle value="pdf">PDF</mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>
  }
  <div class="item">
    <mat-checkbox name="include-action-items" [disabled]="!data.hasActionItems" labelPosition="after" [(ngModel)]="exportData.includeActionItems">{{
      'MEETINGS.EXPORT_DIALOG.ACTION_ITEMS' | translate
    }}</mat-checkbox>
    @if (exportData.includeActionItems) {
      <mat-button-toggle-group name="actions-items-format" [(ngModel)]="exportData.actionItemsFormat">
        @if (data.exportsDetectedActionItems) {
          <mat-button-toggle value="xlsx">XLSX</mat-button-toggle>
        }
        <mat-button-toggle value="csv">CSV</mat-button-toggle>
      </mat-button-toggle-group>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  @if (loading) {
    <app-spinner size="medium"></app-spinner>
  } @else {
    <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
    <button mat-button (click)="onExport()" cdkFocusInitial translate="COMMON.EXPORT" [disabled]="isExportDisabled" color="primary"></button>
  }
</mat-dialog-actions>
